import { Expose } from "class-transformer";
import { DeliveryNoteStatusEnum } from "@altertec_gparn/lib";

export class ChangeDeliveryNoteStatusDto {
  @Expose()
  id: string;

  @Expose()
  status: DeliveryNoteStatusEnum;
}
